<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />

    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">
        {{ App.MessagesAreaScreen.MESSAGE }}
      </span>
      <div class="close-button cursor-pointer" @click.stop="$emit('close')">
        <b-icon icon="close" />
      </div>
    </header>

    <section class="modal-content-container spacing-mb-10">
      <div class="has-text-color-8">
        <label class="has-text-weight-semibold">{{ General.DATE }}:</label>
        <span>
          {{ new Date(messageItem.created_at) | dateFormat("DD/MM/YYYY") }}
        </span>
      </div>
      <div class="has-text-color-8">
        <label class="has-text-weight-semibold">
          {{ App.MessagesAreaScreen.MESSAGE_TITLE }}:
        </label>
        <p class="text-box mb-10">{{ messageItem.title }}</p>
      </div>
      <div class="has-text-color-8">
        <label class="has-text-weight-semibold">
          {{ App.MessagesAreaScreen.MESSAGE }}:
        </label>
        <p class="text-box">{{ messageItem.description }}</p>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { App, General } from "@/utils/constants";

export default {
  name: "ModalViewMessage",

  props: {
    messageItem: {
      type: Object,
      default: () => null
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    })
  },

  methods: {
    close() {
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  min-height: 300px;
  max-height: 80vh;
  background-color: $color-1;

  @media only screen and (max-width: $tablet) {
    width: 100%;
  }
}

.modal-card div.card-body {
  display: flex;
  align-content: flex-start;
  flex-direction: column;
  flex: 1;
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  overflow: auto;
  padding: 0 20px;
  gap: 10px;
}

.text-box {
  width: 100%;
  padding: 5px 10px;
  border: solid $border-color 1px;
  background-color: $color-15;
  border-radius: 5px;
  margin-bottom: 15px;
}
</style>
